module.exports = __webpack_public_path__ + "static/media/operating.11ae4c4d.svg";